// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.33.0
// source: aiChat/aiChat.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";

export const protobufPackage = "aiChat";

export enum EMessageSender {
  Unspecified = 0,
  User = 1,
  AI = 2,
  UNRECOGNIZED = -1,
}

export function eMessageSenderFromJSON(object: any): EMessageSender {
  switch (object) {
    case 0:
    case "Unspecified":
      return EMessageSender.Unspecified;
    case 1:
    case "User":
      return EMessageSender.User;
    case 2:
    case "AI":
      return EMessageSender.AI;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EMessageSender.UNRECOGNIZED;
  }
}

export function eMessageSenderToJSON(object: EMessageSender): string {
  switch (object) {
    case EMessageSender.Unspecified:
      return "Unspecified";
    case EMessageSender.User:
      return "User";
    case EMessageSender.AI:
      return "AI";
    case EMessageSender.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface IAiChatMessage {
  id?: string | undefined;
  content: string;
  sender: EMessageSender;
}

export interface ISendAiChatMessageRequest {
  message: IAiChatMessage | undefined;
  messagesHistory: IAiChatMessage[];
}

function createBaseIAiChatMessage(): IAiChatMessage {
  return { id: undefined, content: "", sender: 0 };
}

export const IAiChatMessage = {
  encode(message: IAiChatMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== undefined) {
      writer.uint32(10).string(message.id);
    }
    if (message.content !== "") {
      writer.uint32(18).string(message.content);
    }
    if (message.sender !== 0) {
      writer.uint32(24).int32(message.sender);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): IAiChatMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIAiChatMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.content = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.sender = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IAiChatMessage {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      content: isSet(object.content) ? globalThis.String(object.content) : "",
      sender: isSet(object.sender) ? eMessageSenderFromJSON(object.sender) : 0,
    };
  },

  toJSON(message: IAiChatMessage): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.content !== "") {
      obj.content = message.content;
    }
    if (message.sender !== 0) {
      obj.sender = eMessageSenderToJSON(message.sender);
    }
    return obj;
  },

  create(base?: DeepPartial<IAiChatMessage>): IAiChatMessage {
    return IAiChatMessage.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<IAiChatMessage>): IAiChatMessage {
    const message = createBaseIAiChatMessage();
    message.id = object.id ?? undefined;
    message.content = object.content ?? "";
    message.sender = object.sender ?? 0;
    return message;
  },
};

function createBaseISendAiChatMessageRequest(): ISendAiChatMessageRequest {
  return { message: undefined, messagesHistory: [] };
}

export const ISendAiChatMessageRequest = {
  encode(message: ISendAiChatMessageRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.message !== undefined) {
      IAiChatMessage.encode(message.message, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.messagesHistory) {
      IAiChatMessage.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ISendAiChatMessageRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseISendAiChatMessageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.message = IAiChatMessage.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.messagesHistory.push(IAiChatMessage.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ISendAiChatMessageRequest {
    return {
      message: isSet(object.message) ? IAiChatMessage.fromJSON(object.message) : undefined,
      messagesHistory: globalThis.Array.isArray(object?.messagesHistory)
        ? object.messagesHistory.map((e: any) => IAiChatMessage.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ISendAiChatMessageRequest): unknown {
    const obj: any = {};
    if (message.message !== undefined) {
      obj.message = IAiChatMessage.toJSON(message.message);
    }
    if (message.messagesHistory?.length) {
      obj.messagesHistory = message.messagesHistory.map((e) => IAiChatMessage.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ISendAiChatMessageRequest>): ISendAiChatMessageRequest {
    return ISendAiChatMessageRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ISendAiChatMessageRequest>): ISendAiChatMessageRequest {
    const message = createBaseISendAiChatMessageRequest();
    message.message = (object.message !== undefined && object.message !== null)
      ? IAiChatMessage.fromPartial(object.message)
      : undefined;
    message.messagesHistory = object.messagesHistory?.map((e) => IAiChatMessage.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
